const replacePlaceholders = (text, valuesObject, rowData = {}, listDataMetadata) => {
  if (!text) {
    return ''
  }

  const placeholderRegex = /\[\[([^[\]]*)\]\]/g

  const replacedText = text.replace(placeholderRegex, (match, placeholder) => {
    // Create a regex to find the fieldKey with a possible suffix (e.g., `__1`)
    const fieldKeyRegex = new RegExp(`^f_${placeholder}(__\\d+)?$`)

    // Find the matching key in rowData that matches the placeholder with or without suffix
    const fieldKey = Object.keys(rowData).find((key) => fieldKeyRegex.test(key))

    // Check if a matching fieldKey exists in rowData and its value is valid
    if (fieldKey && rowData[fieldKey] !== -1 && rowData[fieldKey] !== undefined) {
      let fieldValue = rowData[fieldKey]

      if (Array.isArray(fieldValue)) {
        fieldValue = fieldValue
          .map((value) => {
            // Find the corresponding listDataValue from listDataMetadata
            let listDataValue = listDataMetadata.find(
              (it) => it.list_data_id == value
            )?.list_data_value

            return listDataValue || value
          })
          .join(', ')
      } else {
        // Find the corresponding listDataValue from listDataMetadata
        let listDataValue = listDataMetadata.find(
          (it) => it.list_data_id == fieldValue
        )?.list_data_value

        fieldValue = listDataValue || fieldValue
      }

      return fieldValue
    }

    return valuesObject.hasOwnProperty(placeholder) ? valuesObject[placeholder] : match
  })

  return replacedText
}

module.exports = { replacePlaceholders }
